import React from 'react';

interface TextInputProps {
  id: string;
  label: string;
  type?: 'text' | 'email' | 'tel';
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  autoComplete?: string;
  disabled?: boolean;
  required?: boolean;
  autoFocus?: boolean;
  className?: string;
  minLength?: number;
  maxLength?: number;
}

const TextInput: React.FC<TextInputProps> = ({
  id,
  label,
  type = 'text',
  value,
  onChange,
  placeholder = '',
  autoComplete,
  disabled = false,
  required = false,
  autoFocus = false,
  className = '',
  minLength,
  maxLength,
}) => {
  return (
    <div className={className}>
      <label htmlFor={id} className="block text-sm font-medium text-slate-700 mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <input
        id={id}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full px-3 py-2 border border-slate-300 rounded-md shadow-sm placeholder-slate-400 text-slate-900 focus:outline-none focus:ring-2 focus:ring-[#0C233E] focus:border-transparent disabled:bg-slate-100 disabled:text-slate-500"
        autoComplete={autoComplete}
        disabled={disabled}
        required={required}
        autoFocus={autoFocus}
        minLength={minLength}
        maxLength={maxLength}
      />
    </div>
  );
};

export default TextInput;
